import * as ActionTypes from '../ActionTypes';

const optionalHolidayInitialState = {
    isLoading: false,
    success: false,
    error: false,
    successMessage: "",
    errorMessage: "",
    optionalHolidayData: [],
    employeeOptionalHolidayData: [],
    isLoadingEmployeeOptionalHoliday: false
}

export const OptionalHolidayCalendarReducer = function (state = optionalHolidayInitialState, action) {
    switch (action.type) {
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
                optionalHolidayData: []
            };
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                optionalHolidayData: action.payload?.data?.data
            };
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_UPSERT_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
            };
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_UPSERT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                optionalHolidayData: action.payload?.data?.data
            };
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_UPSERT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
            };
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                optionalHolidayData: action.payload?.data?.data
            };
        case ActionTypes.OPTIONAL_HOLIDAY_CALENDAR_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_GET_REQUEST:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
                employeeOptionalHolidayData: []
            };
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_GET_SUCCESS:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: false,
                success: true,
                successMessage: action.payload?.message,
                employeeOptionalHolidayData: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_GET_ERROR:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_UPSERT_REQUEST:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
            };
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_UPSERT_SUCCESS:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: false,
                success: true,
                successMessage: action.payload?.message,
                employeeOptionalHolidayData: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_UPSERT_ERROR:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_DELETE_REQUEST:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
            };
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: false,
                success: true,
                successMessage: action.payload?.message,
                employeeOptionalHolidayData: action.payload?.data?.data
            };
        case ActionTypes.EMPLOYEE_OPTIONAL_HOLIDAY_DELETE_ERROR:
            return {
                ...state,
                isLoadingEmployeeOptionalHoliday: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        default:
            return state;
    }
}
